module.exports = __webpack_public_path__ + "static/2-002-1bb24fc522d7edf458626f68369e2d83.jpg";